import type { ColumnsType } from "@similarweb/pro-logic-components";

import type { ICommonData, IGroupedDomainData } from "../../../hooks/useCommonColumnsConfig";
import { useCommonColumnsConfig } from "../../../hooks/useCommonColumnsConfig";

import { useShareColumnConfig, type IShareColumnData } from "./useShareColumnConfig";

export type Data = ICommonData & IGroupedDomainData & IShareColumnData;

export const useColumnsConfig = () => {
    const shareColumn = useShareColumnConfig();
    const { groupedDomainColumn, popColumn, trendColumn, yoyColumn } = useCommonColumnsConfig();

    return [groupedDomainColumn, shareColumn, trendColumn, popColumn, yoyColumn] satisfies ColumnsType<Data>;
};
